import { render, staticRenderFns } from "./PriceSummaryItem.vue?vue&type=template&id=2079a323&"
import script from "./PriceSummaryItem.vue?vue&type=script&lang=js&"
export * from "./PriceSummaryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports